module.exports = __webpack_public_path__ + "assets/user-avatar.d78d556d.svg";